import * as types from "../actions/types";

export const initState = {
  id: "",
  token: "",
  driver_category_code: "R",
  referring_ev_charging_site_id: "",
  evChargingSites: {
    name: "",
    description: "",
    address_id: "",
    default_currency_id: "",
    description: "",
    ev_charging_site_group_id: "",
    ev_charging_site_id: "",
    gps_latitude: "",
    gps_location_id: "",
    gps_longitude: "",
    last_updated_at: "",
    last_updated_by: "",
    phone_number: "",
    template_flag: "",
    vat_id: "",
  },
  userAccount: {
    user_role_code: "",
    user_name: "",
    mobile_phone_number: "",
    email_address: "",
    person: {
      sex_code: "",
      first_name: "",
      last_name: "",
      title_code: "",
      date_of_birth: "",
      personAddress: {
        // "person_address_id": null,
        address_type_code: "",
        // "person_id": null,
        // "last_updated_by": null,
        // "last_updated_at": null,
        address: {
          street_line_1: "",
          street_line_2: "",
          zip_code: "",
          state_id: "",
          city_id: "",
          country_id: "",
        },
      },
    },
  },
  loading: false,
  loginError: false,
  tag_id: null,
  creationFailed: {
    error: false,
    message: "",
  },
  password_reset_success: "",
};

const driverReducer = (state = initState, action) => {
  switch (action.type) {
    case types.DRIVER_PROFILE:
      return {
        ...state,
        ...action.payload,
      };
    case types.DRIVER_PROFILE_CREATED:
      return {
        ...state,
        token: action.payload.token,
        id: action.payload.driver.driver_id,
        evChargingSites: {
          ...state.evChargingSites,
          ev_charging_site_id: action.payload.driver.ev_charging_site_id,
        },
        creationFailed: {
          error: false,
          message: "",
        },
      };
    case types.DRIVER_PROFILE_UPDATED:
      return {
        ...state,
        token: action.payload.token,
        id: action.payload.driver_id,
        evChargingSites: {
          ...state.evChargingSites,
          ev_charging_site_id: action.payload.ev_charging_site_id,
        },
        creationFailed: {
          error: false,
          message: "",
        },
      };
    case types.GET_DRIVER_PROFILE:
      return {
        ...state,
        ...action.payload,
        userAccount: {
          ...action.payload.userAccount,
          person: {
            ...action.payload.userAccount.person,
            personAddress: {
              ...(action.payload.userAccount.person.personAddress || {
                // "person_address_id": null,
                address_type_code: "",
                // "person_id": null,
                // "last_updated_by": null,
                // "last_updated_at": null,
                address: {
                  street_line_1: "",
                  street_line_2: "",
                  zip_code: "",
                  state_id: "",
                  city_id: "",
                  country_id: "",
                },
              }),
            },
          },
        },
      };
    case types.CREATE_DRIVER_VEHICLE:
      return {
        ...state,
        vehicles: action.payload,
      };
    case types.DELETE_DRIVER_VEHICLE:
      return {
        ...state,
        vehicles: action.payload,
      };
    case types.UPDATE_DRIVER_VEHICLE:
      let { vehicle, driver_vehicle_id } = action.payload;
      // Select Vehicle to update
      let vehicleToBeUpdated = state.vehicles.filter(
        (v) => v.driver_vehicle_id == driver_vehicle_id
      )[0];
      // remove vehicle which was updated
      let vehicles = state.vehicles.filter(
        (v) => v.driver_vehicle_id !== driver_vehicle_id
      );
      vehicle = {
        ...vehicleToBeUpdated,
        ...vehicle,
      };
      // Add updated vehicle
      vehicles.unshift(vehicle);
      // Update Redux state
      return {
        ...state,
        vehicles: vehicles,
      };
    case types.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        password_reset_success: action.data,
      };
    case types.DRIVER_AUTHENTICATION_SUCCESS:
      return {
        ...state,
        token: action.data.token,
        tag_id: action.data?.driver.tag_id,
        id: action.data.driver.driver_id,
        evChargingSites: {
          ...state.evChargingSites,
          ev_charging_site_id:
            action.data.driver.evChargingSites[0].ev_charging_site_id,
        },
        userAccount: {
          ...state.userAccount,
          person: {
            ...state.userAccount.person,
            first_name: action.data.driver.userAccount.person.first_name,
            last_name: action.data.driver.userAccount.person.last_name,
          },
        },
        loading: false,
        loginError: false,
      };
    case types.DRIVER_AUTHENTICATION_IN_PROCESS:
      return {
        ...state,
        loading: true,
        loginError: false,
      };
    case types.DRIVER_AUTHENTICATION_FAILED:
      return {
        ...state,
        loading: false,
        loginError: true,
      };
    case types.DRIVER_PROFILE_CREATION_FAILED:
      return {
        ...state,
        creationFailed: {
          error: true,
          message: action.payload,
        },
      };
    default:
      return state;
  }
};

export default driverReducer;
